export default __webpack_public_path__ + "3b5e6aaa8adc7f3a9a60233e9ecd248f.png";